import React from 'react';

import TestFUMIGACIJAiDDD from './test1.component';
import TestPPZiBZNR from './test2.component';
import './test.exam.style.scss';




class TestExamComponent extends React.Component{
  constructor() {
    super();

    this.state = {
      clicked: false,
      kliked:false,
      
  
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleKlick=this.handleKlick.bind(this);
  }

 handleClick() {
   this.setState({
     clicked: true

   });
 }
 handleKlick(){
   this.setState({
     kliked:true
   })
 }



    render(){
    

        return(
  

       
    
    <div className='test-exam' style={{display:'flex',justifyContent:'center'}} >  {
     this.state.clicked ? ( 

     <TestFUMIGACIJAiDDD/>

    
    ) : this.state.kliked ?(
   
    <TestPPZiBZNR/>

    
  ) :
  <div>  



<div className='test-exam-container'>       <div className='test-exam-button-container' >
          <div className='test-exam-button'  onClick={this.handleClick}> ФУМИГАЦИЈА И ДДД</div>
          <div className='test-exam-button' onClick={this.handleKlick}> ППЗ,БЗНР И ИКТ </div>
          </div>
      </div>    
      </div>
     }
    </div>


       

       

          
       

    
   

);}}


export default TestExamComponent;